import React, { useMemo } from 'react';

import type { IProps } from './models';

export const GridLayout = ({
    children,
    className,
    columnGap = 24,
    gridAutoColumns,
    gridAutoFlow,
    gridAutoRows,
    gridTemplateAreas,
    gridTemplateColumns,
    gridTemplateRows,
    rowGap = 24,
}: IProps) => {
    const styles = useMemo(
        () => ({
            display: 'grid',
            gridTemplateColumns,
            gridAutoColumns,
            gap: `${rowGap}px ${columnGap}px`,
            gridAutoFlow,
            gridAutoRows,
            gridTemplateAreas,
            gridTemplateRows,
        }),
        [
            columnGap,
            gridAutoColumns,
            gridAutoFlow,
            gridAutoRows,
            gridTemplateAreas,
            gridTemplateColumns,
            gridTemplateRows,
            rowGap,
        ]
    );

    return (
        <div className={className} style={styles}>
            {children}
        </div>
    );
};
